/* eslint-disable */
import axios from "axios"
export default {
    methods: {
        /**
            * Método que serve para popular a tabela
            * @param  {Object} params - Objeto padrão usado na querystring
            * @return {Promise<
            * {
            *    "conteudo": [
            *        {
            *        "analistaResponsavel": String,
            *        "codigo": Number,
            *        "nome": String,
            *        "primeiroDia": Number,
            *        "segundoDia": Number
            *        }
            *    ],
            *    "numeroPagina": Number,
            *    "tamanhoPagina": Number,
            *    "totalElementos": Number,
            *    "totalPaginas": Number
            * }
            * >}
        */
        getTabelaAdministracao (params) {
            return axios.get(this.CriarUrl({ resource: "/adm/unimeds", params }));
        },
        
        /**
            * Recupera todos os analistas
            * @return {Promise<[
            *    {
            *        "cdUnimed": Number,
            *        "email": String,
            *        "idUsuarioUnimed": Number,
            *        "login": String,
            *        "nome": String
            *    }
            *    ]>}
        */
        getAnalistasUnimed() {
            return axios.get(this.CriarUrl({ resource: "analista/all" }));
        },
        getTipoAtucao() {
            return axios.get(this.CriarUrl({
                resource: `prestadores/tipoAtuacao`
            }))
        }
    }
}